import { ChangeEvent, SetStateAction, useContext, useEffect, useState } from "react";
import {
    Box,
    Checkbox,
    FormControlLabel,
    Snackbar,
    TextField,
    Typography,
} from "@mui/material";
import { Paper, Stack, TableBody } from "@mui/material";
import { TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import {
    StyledTableCell,
    StyledTableCellRight,
    StyledTableHead,
} from "../../../Styles/tabelCellStyled/customTableCell";
import { CustomTextField } from "../../../Styles/theme/customThemeprovider";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import BasicPopover from "../../../Components/Popover";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { Alert } from "../../../Components/Alert/Alert";
import { IAdubacao } from "../../../Interfaces/anexos/anexo1/composicao_adubacao_azoto_nutrientes1_4_7";
import { del, get, post } from "../../../Services/tokenConfig";
import { ICabecalho } from "../../../Interfaces/anexos/anexo1/analise_e_foliar1_1_3";
import { func_print } from "../../../Func_genericas/func_print";
import { IPlanoNutrientes } from "../../../Interfaces/anexos/anexo1/plano_nutrientes1_3";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";


interface ComposicaoQ1Form_prop {
    obj_anexo_cabecalho_selecionado: ICabecalho | undefined;
    set_obj_da_tabela_3_atualizado: React.Dispatch<SetStateAction<IPlanoNutrientes | undefined>>;

}

export const AdubacaoForm: React.FC<ComposicaoQ1Form_prop> = ({ obj_anexo_cabecalho_selecionado, set_obj_da_tabela_3_atualizado }) => {
    const location = useLocation();
    const is_historico = location.state?.is_historico ?? false;

    const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState(false);
    const auth = useContext(AuthContext);
    const [flag_editar, set_flag_editar] = useState(true);
    const [createTable, setCreateTable] = useState(false);
    const [message, setMessage] = useState("");
    const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
    const [openSnackError, setOpenSnackError] = React.useState(false);
    const [error_especies_camp1, set_error_especies_camp1] = React.useState(false);
    const [error_especies_camp2, set_error_especies_camp2] = React.useState(false);
    const [error_quantidade_camp1, set_error_quantidade_camp1] = React.useState(false);
    const [error_quantidade_camp2, set_error_quantidade_camp2] = React.useState(false);
    const [error_quantidade_camp3, set_error_quantidade_camp3] = React.useState(false);
    const [error_quantidade_camp4, set_error_quantidade_camp4] = React.useState(false);
    const [error_quantidade_camp5, set_error_quantidade_camp5] = React.useState(false);
    const [error_quantidade_camp6, set_error_quantidade_camp6] = React.useState(false);
    const [error_quantidade_camp7, set_error_quantidade_camp7] = React.useState(false);
    const [error_quantidade_camp8, set_error_quantidade_camp8] = React.useState(false);
    const [error_considerar_camp1, set_error_considerar_camp1] = React.useState(false);
    const [error_considerar_camp2, set_error_considerar_camp2] = React.useState(false);
    const [error_considerar_camp3, set_error_considerar_camp3] = React.useState(false);
    const [error_considerar_camp4, set_error_considerar_camp4] = React.useState(false);
    const [error_considerar_camp5, set_error_considerar_camp5] = React.useState(false);
    const [error_considerar_camp6, set_error_considerar_camp6] = React.useState(false);
    const [error_considerar_camp7, set_error_considerar_camp7] = React.useState(false);
    const [error_considerar_camp8, set_error_considerar_camp8] = React.useState(false);
    const [obj_anexo, set_obj_anexo] = useState<IAdubacao>();
    const [obj_anexo_lista, set_obj_anexo_lista] = useState<IAdubacao[]>();
    const [existe_cabecalho, set_existe_cabecalho] = useState(false)


    const [isLoading, setIsLoading] = useState(false);


    const [flag_editado, set_flag_editado] = React.useState(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);


    const handleCloseDialog = () => {
        set_obj_anexo(undefined)
        set_flag_editar(false)

        set_error_especies_camp1(false)
        set_error_especies_camp2(false)
        set_error_quantidade_camp1(false)
        set_error_quantidade_camp2(false)
        set_error_quantidade_camp3(false)
        set_error_quantidade_camp4(false)
        set_error_quantidade_camp5(false)
        set_error_quantidade_camp6(false)
        set_error_quantidade_camp7(false)
        set_error_quantidade_camp8(false)
        set_error_considerar_camp1(false)
        set_error_considerar_camp2(false)
        set_error_considerar_camp3(false)
        set_error_considerar_camp4(false)
        set_error_considerar_camp5(false)
        set_error_considerar_camp6(false)
        set_error_considerar_camp7(false)
        set_error_considerar_camp8(false)

        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };

    // onChange criar
    const onInputChange = (event: any) => {
        const { name, value, type, checked } = event.target;
        set_flag_editado(true)

        if (type === "checkbox") {
            set_obj_anexo((prev: any) => {
                return {
                    ...prev,
                    [name]: checked,
                };
            });
        } else {
            if (name === 'especies_camp1') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_especies_camp1(true)
                } else {
                    set_error_especies_camp1(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'especies_camp2') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_especies_camp2(true)
                } else {
                    set_error_especies_camp2(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'quantidade_camp1') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_quantidade_camp1(true)
                } else {
                    set_error_quantidade_camp1(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'quantidade_camp2') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_quantidade_camp2(true)
                } else {
                    set_error_quantidade_camp2(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'quantidade_camp3') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_quantidade_camp3(true)
                } else {
                    set_error_quantidade_camp3(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'quantidade_camp4') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_quantidade_camp4(true)
                } else {
                    set_error_quantidade_camp4(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'quantidade_camp5') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_quantidade_camp5(true)
                } else {
                    set_error_quantidade_camp5(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'quantidade_camp6') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_quantidade_camp6(true)
                } else {
                    set_error_quantidade_camp6(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'quantidade_camp7') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_quantidade_camp7(true)
                } else {
                    set_error_quantidade_camp7(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'quantidade_camp8') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_quantidade_camp8(true)
                } else {
                    set_error_quantidade_camp8(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'considerar_camp1') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_considerar_camp1(true)
                } else {
                    set_error_considerar_camp1(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'considerar_camp2') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_considerar_camp2(true)
                } else {
                    set_error_considerar_camp2(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'considerar_camp3') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_considerar_camp3(true)
                } else {
                    set_error_considerar_camp3(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'considerar_camp4') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_considerar_camp4(true)
                } else {
                    set_error_considerar_camp4(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'considerar_camp5') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_considerar_camp5(true)
                } else {
                    set_error_considerar_camp5(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'considerar_camp6') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_considerar_camp6(true)
                } else {
                    set_error_considerar_camp6(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'considerar_camp7') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_considerar_camp7(true)
                } else {
                    set_error_considerar_camp7(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'considerar_camp8') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_considerar_camp8(true)
                } else {
                    set_error_considerar_camp8(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else {
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: value,
                }));
            }


        }


    };

    const handle_delete_anexo = async () => {
        try {
            setIsLoading(true);

            let res = await del(auth.token.cookie_token,
                `delete__reg_anexo_um_cinco/${obj_anexo?.id_composicao_verde}`
            );
            if (res.status === 200) {
                let lista_aux: any = obj_anexo_lista?.filter((el) => {
                    if (el.id_composicao_verde !== obj_anexo?.id_composicao_verde) {
                        return el
                    }
                })
                set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
                set_obj_anexo(undefined)
                if (lista_aux === undefined || lista_aux.length === 0) {
                    setCreateTable(true)
                }
                set_obj_da_tabela_3_atualizado(res.data.result)

                setMessage("Registo eliminado com sucesso!");
                set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
                setOpenSnackSuccess(true);

            } else {
                setMessage("Erro ao eliminar o registo!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {
            func_print("handle_delete_anexo", error, true);
            setIsLoading(false);
            setMessage("Erro ao eliminar o registo!");
            setOpenSnackError(true);
        }
    };


    const handleCloseSnack = () => {

        setOpenSnackSuccess(false);
        setOpenSnackError(false);
    };
    const get_info = async () => {
        try {
            let res = await get(auth.token.cookie_token,
                `/get_reg_anexo_um_cinco_cabecalho/${obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho}`
            );

            if (res.status === 200) {
                if (res.data.result.length !== 0) {
                    set_obj_anexo_lista(res.data.result);
                } else {
                    setCreateTable(true)
                    set_flag_editar(false)
                }
            } else {
                setMessage("Erro a carregar informação!");
                setOpenSnackError(true);
            }

            setIsLoading(false);
        } catch (error) {
            func_print("get_info", error, true);
            setMessage("Erro!");

            setOpenSnackError(true);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        (async () => {
            if (obj_anexo_cabecalho_selecionado !== undefined) {

                await get_info();
                set_existe_cabecalho(true)
                set_flag_editar(false)

            } else {
                set_existe_cabecalho(false)
                set_obj_anexo_lista([]);
                set_flag_editar(true)


            }
        })();
    }, [obj_anexo_cabecalho_selecionado]);

    const handle_criar_anexo = async () => {
        if (error_considerar_camp1 || error_considerar_camp2 || error_considerar_camp3 || error_considerar_camp4 || error_considerar_camp5 || error_considerar_camp6 || error_considerar_camp7 || error_considerar_camp8 || error_especies_camp1 || error_especies_camp2 || error_quantidade_camp1 || error_quantidade_camp2 || error_quantidade_camp3 || error_quantidade_camp4 || error_quantidade_camp5 || error_quantidade_camp6 || error_quantidade_camp7 || error_quantidade_camp8) {
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);

        } else {

            try {
                setIsLoading(true);

                let data = await post(auth.token.cookie_token, "new_reg_anexo_um_cinco", {
                    payload: {

                        id_composicao_verde: 0,
                        especies_camp1: obj_anexo?.especies_camp1 === undefined ? '' : obj_anexo?.especies_camp1,
                        especies_camp2: obj_anexo?.especies_camp2 === undefined ? '' : obj_anexo?.especies_camp2,
                        nutriente_camp1: obj_anexo?.nutriente_camp1 === undefined ? '' : obj_anexo?.nutriente_camp1,
                        nutriente_camp2: obj_anexo?.nutriente_camp2 === undefined ? '' : obj_anexo?.nutriente_camp2,
                        nutriente_camp3: obj_anexo?.nutriente_camp3 === undefined ? '' : obj_anexo?.nutriente_camp3,
                        nutriente_camp4: obj_anexo?.nutriente_camp4 === undefined ? '' : obj_anexo?.nutriente_camp4,
                        quantidade_camp1: obj_anexo?.quantidade_camp1 === undefined ? '' : obj_anexo?.quantidade_camp1,
                        quantidade_camp2: obj_anexo?.quantidade_camp2 === undefined ? '' : obj_anexo?.quantidade_camp2,
                        quantidade_camp3: obj_anexo?.quantidade_camp3 === undefined ? '' : obj_anexo?.quantidade_camp3,
                        quantidade_camp4: obj_anexo?.quantidade_camp4 === undefined ? '' : obj_anexo?.quantidade_camp4,
                        quantidade_camp5: obj_anexo?.quantidade_camp5 === undefined ? '' : obj_anexo?.quantidade_camp5,
                        quantidade_camp6: obj_anexo?.quantidade_camp6 === undefined ? '' : obj_anexo?.quantidade_camp6,
                        quantidade_camp7: obj_anexo?.quantidade_camp7 === undefined ? '' : obj_anexo?.quantidade_camp7,
                        quantidade_camp8: obj_anexo?.quantidade_camp8 === undefined ? '' : obj_anexo?.quantidade_camp8,
                        considerar_camp1: obj_anexo?.considerar_camp1 === undefined ? '' : obj_anexo?.considerar_camp1,
                        considerar_camp2: obj_anexo?.considerar_camp2 === undefined ? '' : obj_anexo?.considerar_camp2,
                        considerar_camp3: obj_anexo?.considerar_camp3 === undefined ? '' : obj_anexo?.considerar_camp3,
                        considerar_camp4: obj_anexo?.considerar_camp4 === undefined ? '' : obj_anexo?.considerar_camp4,
                        considerar_camp5: obj_anexo?.considerar_camp5 === undefined ? '' : obj_anexo?.considerar_camp5,
                        considerar_camp6: obj_anexo?.considerar_camp6 === undefined ? '' : obj_anexo?.considerar_camp6,
                        considerar_camp7: obj_anexo?.considerar_camp7 === undefined ? '' : obj_anexo?.considerar_camp7,
                        considerar_camp8: obj_anexo?.considerar_camp8 === undefined ? '' : obj_anexo?.considerar_camp8,
                        origem_tabela: obj_anexo?.origem_tabela === undefined ? false : obj_anexo?.origem_tabela,
                        origem_analise: obj_anexo?.origem_analise === undefined ? false : obj_anexo?.origem_analise,
                        tabela: obj_anexo?.tabela === undefined ? '' : obj_anexo?.tabela,
                        analise: obj_anexo?.analise === undefined ? null : obj_anexo?.analise,
                        id_anexo_um_cabecalho: obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho,
                        last_update: new Date().toISOString(),
                        create_date: new Date().toISOString(),
                        uuid: ""
                    }
                })
                if (data.status === 200) {
                    setMessage("Operação efetuada com sucesso!");
                    setOpenSnackSuccess(true);
                    set_obj_anexo_lista([data.data.result[0]])
                    set_obj_da_tabela_3_atualizado(data.data.result[1])
                    set_flag_editar(false)
                    set_obj_anexo(undefined)
                    setCreateTable(false)
                    set_flag_editado(false)

                } else {
                    setMessage("Erro ao efetuar a sua operação!");
                    setOpenSnackError(true);
                }
                setIsLoading(false);

            } catch (error) {
                func_print('handle_criar_anexo', error, true)
                setIsLoading(false);

                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
            }
        }
    }
    const handle_update_anexo = async () => {
        try {
            setIsLoading(true);
            let res = await post(auth.token.cookie_token, "update_reg_anexo_um_cinco", { payload: obj_anexo });

            if (res.status === 200) {
                let lista_aux: any = obj_anexo_lista?.map((el) => {
                    if (el.id_composicao_verde !== obj_anexo?.id_composicao_verde) {
                        return el
                    } else {
                        return res.data.result[0]
                    }
                })
                set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
                set_obj_da_tabela_3_atualizado(res.data.result[1])
                set_flag_editar(false)
                set_obj_anexo(undefined);
                setMessage("Gravado com sucesso!");
                setOpenSnackSuccess(true);
                set_flag_editado(false)


            } else {
                setMessage("Erro ao gravar!");

                setOpenSnackError(true);
            }

            setIsLoading(false);
        } catch (error) {
            func_print("handle_update_anexo", error, true);
            setMessage("Erro ao gravar!");

            setOpenSnackError(true);
            setIsLoading(false);
        }
    };

    return (
        <TableContainer
            component={Paper}
            variant="outlined"
            sx={{
                height: "auto",
                width: "auto",
                margin: 2,
                padding: 2,
            }}
        >
            <Snackbar
                open={openSnackSuccess}
                autoHideDuration={2000}
                onClose={handleCloseSnack}
            >
                <Alert
                    onClose={handleCloseSnack}
                    severity="success"
                    sx={{ width: "100%" }}
                >
                    {message}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openSnackError}
                autoHideDuration={2000}
                onClose={handleCloseSnack}
            >
                <Alert
                    onClose={handleCloseSnack}
                    severity="error"
                    sx={{ width: "100%" }}
                >
                    {message}

                </Alert>
            </Snackbar>
            <table style={{ width: "100%" }}>
                <TableHead>
                    <TableRow>

                        {
                            obj_anexo_lista?.length === 0 || obj_anexo_lista === undefined ?
                                <>
                                    <TableCell
                                        colSpan={8}
                                        sx={{
                                            fontWeight: 600,
                                            textAlign: "left",
                                            fontFamily: "candara",
                                            fontSize: 16,
                                        }}
                                    >
                                        1.5 - Composição da adubação verde
                                        <BasicPopover
                                            text={
                                                "No caso do beneficiário ter efetuado análises, os boletins de análise devem ser mantidos pelo beneficiário por forma a serem consultados sempre que necessário pelas entidades que monitorizam, verificam a aplicação da legislação nacional aplicável no âmbito da gestão de nutrientes disponibilizados às culturas."
                                            }
                                        />
                                    </TableCell>
                                    {

                                        existe_cabecalho === false ? <></> :
                                            createTable === false ?
                                                <TableCell>
                                                    <Stack direction="row" justifyContent="end">
                                                        {is_historico === true ? <></> :

                                                            <BarraDeFerramentas
                                                                mostrarBotaoNovo
                                                                textoBotaoNovo="Registar"
                                                                aoClicarNovo={() => setCreateTable(true)}
                                                            />}
                                                    </Stack>
                                                </TableCell>
                                                :
                                                <TableCell>
                                                    {is_historico === true ? <></> :

                                                        <ButtonCadernos

                                                            mostrarBotaoGravar
                                                            aoClicarGravar={() => { handle_criar_anexo() }}
                                                        />}
                                                </TableCell>}
                                </>
                                : <></>

                        }
                    </TableRow>
                </TableHead>

                {createTable === false ?
                    <>
                        {/* <TableRow>
                                <StyledTableHead rowSpan={2}>Espécies</StyledTableHead>
                                <StyledTableHead>% de Leguminosas</StyledTableHead>
                                <StyledTableHead>% de Gramíneas</StyledTableHead>
                            </TableRow>
                            <TableRow>
                                <StyledTableCell>{obj_anexo?.especies_camp1 === undefined ? '' : obj_anexo?.especies_camp1}</StyledTableCell>
                                <StyledTableCell>{obj_anexo?.especies_camp2 === undefined ? '' : obj_anexo?.especies_camp2}</StyledTableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                                <StyledTableHead>Nutriente </StyledTableHead>
                                <StyledTableHead>N</StyledTableHead>
                                <StyledTableHead>P2O5</StyledTableHead>
                                <StyledTableHead>K2O</StyledTableHead>
                                <StyledTableHead>Mg</StyledTableHead>
                                <StyledTableHead>Outros</StyledTableHead>
                                <StyledTableHead>{obj_anexo?.nutriente_camp1 === undefined ? '' : obj_anexo?.nutriente_camp1}</StyledTableHead>
                                <StyledTableHead>{obj_anexo?.nutriente_camp2 === undefined ? '' : obj_anexo?.nutriente_camp2}</StyledTableHead>
                                <StyledTableHead>{obj_anexo?.nutriente_camp3 === undefined ? '' : obj_anexo?.nutriente_camp3}</StyledTableHead>
                                <StyledTableHead>{obj_anexo?.nutriente_camp4 === undefined ? '' : obj_anexo?.nutriente_camp4}</StyledTableHead>
                            </TableRow>
                            <TableRow>
                                <StyledTableHead>Quantidade (mg/kg)</StyledTableHead>
                                <StyledTableCell>{obj_anexo?.quantidade_camp1 === undefined ? '' : obj_anexo?.quantidade_camp1}</StyledTableCell>
                                <StyledTableCell>{obj_anexo?.quantidade_camp2 === undefined ? '' : obj_anexo?.quantidade_camp2}</StyledTableCell>
                                <StyledTableCell>{obj_anexo?.quantidade_camp3 === undefined ? '' : obj_anexo?.quantidade_camp3}</StyledTableCell>
                                <StyledTableCell>{obj_anexo?.quantidade_camp4 === undefined ? '' : obj_anexo?.quantidade_camp4}</StyledTableCell>
                                <StyledTableCell>{obj_anexo?.quantidade_camp5 === undefined ? '' : obj_anexo?.quantidade_camp5}</StyledTableCell>
                                <StyledTableCell>{obj_anexo?.quantidade_camp6 === undefined ? '' : obj_anexo?.quantidade_camp6}</StyledTableCell>
                                <StyledTableCell>{obj_anexo?.quantidade_camp7 === undefined ? '' : obj_anexo?.quantidade_camp7}</StyledTableCell>
                                <StyledTableCell>{obj_anexo?.quantidade_camp8 === undefined ? '' : obj_anexo?.quantidade_camp8}</StyledTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledTableHead>
                                    A considerar no plano de fertilização nos casos em que se
                                    recorra a esta prática
                                    <Stack direction="row" justifyContent="center">
                                        (kg/ha)
                                        <Box margin={-1} padding={0}>
                                            <BasicPopover
                                                text={
                                                    "Parcela usada no cálculo automático do campo «previsão total de nutrientes a disponibilizar à cultura» do quadro 3 - Plano de aplicação em função dos resultados das análises ou dos valores tabelados em referência bibliográfica relativamente à composição da adubação verde efetuada."
                                                }
                                            />
                                        </Box>
                                    </Stack>
                                </StyledTableHead>
                                <StyledTableCell>{obj_anexo?.considerar_camp1 === undefined ? '' : obj_anexo?.considerar_camp1}</StyledTableCell>
                                <StyledTableCell>{obj_anexo?.considerar_camp2 === undefined ? '' : obj_anexo?.considerar_camp2}</StyledTableCell>
                                <StyledTableCell>{obj_anexo?.considerar_camp3 === undefined ? '' : obj_anexo?.considerar_camp3}</StyledTableCell>
                                <StyledTableCell>{obj_anexo?.considerar_camp4 === undefined ? '' : obj_anexo?.considerar_camp4}</StyledTableCell>
                                <StyledTableCell>{obj_anexo?.considerar_camp5 === undefined ? '' : obj_anexo?.considerar_camp5}</StyledTableCell>
                                <StyledTableCell>{obj_anexo?.considerar_camp6 === undefined ? '' : obj_anexo?.considerar_camp6}</StyledTableCell>
                                <StyledTableCell>{obj_anexo?.considerar_camp7 === undefined ? '' : obj_anexo?.considerar_camp7}</StyledTableCell>
                                <StyledTableCell>{obj_anexo?.considerar_camp8 === undefined ? '' : obj_anexo?.considerar_camp8}</StyledTableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    rowSpan={2}
                                    sx={{
                                        textAlign: "left",
                                        fontWeight: 600,
                                        fontFamily: "candara",
                                    }}
                                >
                                    <Stack
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                    >
                                        Origem dos dados:
                                        <BasicPopover
                                            text={
                                                "Assinalar com uma X o campo correspondente à origem dos dados"
                                            }
                                        />
                                    </Stack>
                                </TableCell>
                                <TableCell colSpan={2}>
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        justifyContent="left"
                                    >
                                        <FormControlLabel
                                            name="origem_tabela"
                                            label={
                                                <Typography fontFamily="candara" fontSize={16}>
                                                    a) Tabela - Referência bibliográfica:
                                                </Typography>
                                            }
                                            control={
                                                <Checkbox
                                                    disabled
                                                    value={
                                                        obj_anexo?.origem_tabela
                                                    }
                                                    sx={{
                                                        color: "#aaaaaa",
                                                        "&.Mui-checked": {
                                                            color: "#C94F1E",
                                                        },
                                                    }}
                                                />
                                            }
                                        />
                                    </Stack>
                                </TableCell>
                                <TableCell colSpan={2}>{obj_anexo?.tabela === undefined ? '' : obj_anexo?.tabela}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={2}>
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        justifyContent="left"
                                    >
                                        <FormControlLabel
                                            name="origem_analise"
                                            label={
                                                <Typography fontFamily="candara" fontSize={16}>
                                                    b) Análise - Data:
                                                </Typography>
                                            }
                                            disabled
                                            control={
                                                <Checkbox
                                                    value={
                                                        obj_anexo?.origem_analise === true &&
                                                        obj_anexo?.origem_analise
                                                    }
                                                    sx={{
                                                        color: "#aaaaaa",
                                                        "&.Mui-checked": {
                                                            color: "#C94F1E",
                                                        },
                                                    }}
                                                />
                                            }
                                        />
                                    </Stack>
                                </TableCell>

                                <TableCell colSpan={2}>{obj_anexo?.analise === undefined ? '' : obj_anexo?.analise}</TableCell>
                            </TableRow> */}
                    </>
                    :
                    <TableBody>
                        <TableRow>
                            <StyledTableHead rowSpan={2}>Espécies</StyledTableHead>
                            <StyledTableHead>% de Leguminosas</StyledTableHead>
                            <StyledTableHead>% de Gramíneas</StyledTableHead>
                        </TableRow>
                        <TableRow>
                            <StyledTableCell>
                                <CustomTextField
                                    name="especies_camp1"
                                    value={obj_anexo?.especies_camp1 === undefined ? '' : obj_anexo?.especies_camp1.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_especies_camp1}
                                    helperText={error_especies_camp1 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="especies_camp2"
                                    value={obj_anexo?.especies_camp2 === undefined ? '' : obj_anexo?.especies_camp2.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_especies_camp2}
                                    helperText={error_especies_camp2 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell></TableCell>
                        </TableRow>
                        <TableRow>
                            <StyledTableHead>Nutriente </StyledTableHead>
                            <StyledTableHead>N</StyledTableHead>
                            <StyledTableHead>P2O5</StyledTableHead>
                            <StyledTableHead>K2O</StyledTableHead>
                            <StyledTableHead>Mg</StyledTableHead>
                            <StyledTableHead>
                                <CustomTextField
                                    name="nutriente_camp1"
                                    value={obj_anexo?.nutriente_camp1 === undefined ? '' : obj_anexo?.nutriente_camp1}
                                    onChange={onInputChange}
                                />
                            </StyledTableHead>
                            <StyledTableHead>
                                <CustomTextField
                                    name="nutriente_camp2"
                                    value={obj_anexo?.nutriente_camp2 === undefined ? '' : obj_anexo?.nutriente_camp2}
                                    onChange={onInputChange}
                                />
                            </StyledTableHead>
                            <StyledTableHead>
                                <CustomTextField
                                    name="nutriente_camp3"
                                    value={obj_anexo?.nutriente_camp3 === undefined ? '' : obj_anexo?.nutriente_camp3}
                                    onChange={onInputChange}
                                />
                            </StyledTableHead>
                            <StyledTableHead>
                                <CustomTextField
                                    name="nutriente_camp4"
                                    value={obj_anexo?.nutriente_camp4 === undefined ? '' : obj_anexo?.nutriente_camp4}
                                    onChange={onInputChange}
                                />
                            </StyledTableHead>
                        </TableRow>
                        <TableRow>
                            <StyledTableHead>Quantidade (mg/kg)</StyledTableHead>
                            <StyledTableCell>
                                <CustomTextField
                                    name="quantidade_camp1"
                                    value={obj_anexo?.quantidade_camp1 === undefined ? '' : obj_anexo?.quantidade_camp1.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_quantidade_camp1}
                                    helperText={error_quantidade_camp1 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="quantidade_camp2"
                                    value={obj_anexo?.quantidade_camp2 === undefined ? '' : obj_anexo?.quantidade_camp2.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_quantidade_camp2}
                                    helperText={error_quantidade_camp2 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="quantidade_camp3"
                                    value={obj_anexo?.quantidade_camp3 === undefined ? '' : obj_anexo?.quantidade_camp3.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_quantidade_camp3}
                                    helperText={error_quantidade_camp3 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="quantidade_camp4"
                                    value={obj_anexo?.quantidade_camp4 === undefined ? '' : obj_anexo?.quantidade_camp4.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_quantidade_camp4}
                                    helperText={error_quantidade_camp4 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="quantidade_camp5"
                                    value={obj_anexo?.quantidade_camp5 === undefined ? '' : obj_anexo?.quantidade_camp5.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_quantidade_camp5}
                                    helperText={error_quantidade_camp5 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="quantidade_camp6"
                                    value={obj_anexo?.quantidade_camp6 === undefined ? '' : obj_anexo?.quantidade_camp6.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_quantidade_camp6}
                                    helperText={error_quantidade_camp6 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="quantidade_camp7"
                                    value={obj_anexo?.quantidade_camp7 === undefined ? '' : obj_anexo?.quantidade_camp7.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_quantidade_camp7}
                                    helperText={error_quantidade_camp7 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="quantidade_camp8"
                                    value={obj_anexo?.quantidade_camp8 === undefined ? '' : obj_anexo?.quantidade_camp8.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_quantidade_camp8}
                                    helperText={error_quantidade_camp8 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <StyledTableHead>
                                A considerar no plano de fertilização nos casos em que se
                                recorra a esta prática
                                <Stack direction="row" justifyContent="center">
                                    (kg/ha)
                                    <Box margin={-1} padding={0}>
                                        <BasicPopover
                                            text={
                                                "Parcela usada no cálculo automático do campo «previsão total de nutrientes a disponibilizar à cultura» do quadro 3 - Plano de aplicação em função dos resultados das análises ou dos valores tabelados em referência bibliográfica relativamente à composição da adubação verde efetuada."
                                            }
                                        />
                                    </Box>
                                </Stack>
                            </StyledTableHead>
                            <StyledTableCell>
                                <CustomTextField
                                    name="considerar_camp1"
                                    value={obj_anexo?.considerar_camp1 === undefined ? '' : obj_anexo?.considerar_camp1.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_considerar_camp1}
                                    helperText={error_considerar_camp1 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="considerar_camp2"
                                    value={obj_anexo?.considerar_camp2 === undefined ? '' : obj_anexo?.considerar_camp2.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_considerar_camp2}
                                    helperText={error_considerar_camp2 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="considerar_camp3"
                                    value={obj_anexo?.considerar_camp3 === undefined ? '' : obj_anexo?.considerar_camp3.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_considerar_camp3}
                                    helperText={error_considerar_camp3 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="considerar_camp4"
                                    value={obj_anexo?.considerar_camp4 === undefined ? '' : obj_anexo?.considerar_camp4.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_considerar_camp4}
                                    helperText={error_considerar_camp4 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="considerar_camp5"
                                    value={obj_anexo?.considerar_camp5 === undefined ? '' : obj_anexo?.considerar_camp5.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_considerar_camp5}
                                    helperText={error_considerar_camp5 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="considerar_camp6"
                                    value={obj_anexo?.considerar_camp6 === undefined ? '' : obj_anexo?.considerar_camp6.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_considerar_camp6}
                                    helperText={error_considerar_camp6 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="considerar_camp7"
                                    value={obj_anexo?.considerar_camp7 === undefined ? '' : obj_anexo?.considerar_camp7.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_considerar_camp7}
                                    helperText={error_considerar_camp7 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                            <StyledTableCell>
                                <CustomTextField
                                    name="considerar_camp8"
                                    value={obj_anexo?.considerar_camp8 === undefined ? '' : obj_anexo?.considerar_camp8.toString().replace('.', ',')}
                                    onChange={onInputChange}
                                    error={error_considerar_camp8}
                                    helperText={error_considerar_camp8 ? "Apenas números são aceites" : ""}
                                />
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell
                                rowSpan={2}
                                sx={{
                                    textAlign: "left",
                                    fontWeight: 600,
                                    fontFamily: "candara",
                                }}
                            >
                                <Stack
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    Origem dos dados:
                                    <BasicPopover
                                        text={
                                            "Assinalar com uma X o campo correspondente à origem dos dados"
                                        }
                                    />
                                </Stack>
                            </TableCell>
                            <TableCell colSpan={2}>
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="left"
                                >
                                    <FormControlLabel
                                        name="origem_tabela"
                                        label={
                                            <Typography fontFamily="candara" fontSize={16}>
                                                a) Tabela - Referência bibliográfica:
                                            </Typography>
                                        }
                                        aria-readonly
                                        control={
                                            <Checkbox
                                                checked={!!obj_anexo?.origem_tabela}
                                                onChange={onInputChange}
                                                name="origem_tabela"
                                                disabled={!!flag_editar}
                                                sx={{
                                                    color: "#aaaaaa",
                                                    "&.Mui-checked": {
                                                        color: "#C94F1E",
                                                    },
                                                }}
                                            />
                                        }
                                    />
                                </Stack>
                            </TableCell>
                            <TableCell colSpan={2}>
                                <CustomTextField
                                    name="tabela"
                                    value={obj_anexo?.tabela === undefined ? '' : obj_anexo?.tabela}
                                    onChange={onInputChange}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2}>
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="left"
                                >
                                    <FormControlLabel
                                        name="origem_analise"
                                        label={
                                            <Typography fontFamily="candara" fontSize={16}>
                                                b) Análise - Data:
                                            </Typography>
                                        }
                                        aria-readonly
                                        control={
                                            <Checkbox
                                                checked={!!obj_anexo?.origem_analise}
                                                onChange={onInputChange}
                                                name="origem_analise"
                                                disabled={!!flag_editar}
                                                sx={{
                                                    color: "#aaaaaa",
                                                    "&.Mui-checked": {
                                                        color: "#C94F1E",
                                                    },
                                                }}
                                            />
                                        }
                                    />
                                </Stack>
                            </TableCell>

                            <TableCell colSpan={2}>
                                <TextField
                                    variant="filled"
                                    type="date"
                                    inputProps={{
                                        style: { fontSize: 12, fontFamily: "verdana" },
                                    }}
                                    name="analise"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={obj_anexo?.analise === undefined ? '' : obj_anexo?.analise}
                                    onChange={onInputChange}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                }
                {obj_anexo_lista?.map((tab, key) => {
                    if (tab.id_anexo_um_cabecalho === obj_anexo?.id_anexo_um_cabecalho) {
                        return (
                            <TableBody key={key}>
                                <TableRow>
                                    <TableCell
                                        colSpan={8}
                                        sx={{
                                            fontWeight: 600,
                                            textAlign: "left",
                                            fontFamily: "candara",
                                            fontSize: 16,
                                        }}
                                    >
                                        1.5 - Composição da adubação verde
                                        <BasicPopover
                                            text={
                                                "No caso do beneficiário ter efetuado análises, os boletins de análise devem ser mantidos pelo beneficiário por forma a serem consultados sempre que necessário pelas entidades que monitorizam, verificam a aplicação da legislação nacional aplicável no âmbito da gestão de nutrientes disponibilizados às culturas."
                                            }
                                        />
                                    </TableCell>

                                    <TableCell>
                                        <ButtonCadernos
                                            mostrarBotaoGravar
                                            aoClicarGravar={() => { handle_update_anexo() }}
                                            mostrarBotaoCancelar
                                            aoClicarCancelar={() => {
                                                if (flag_editado) {
                                                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                                } else {
                                                    set_obj_anexo(undefined)
                                                    set_flag_editar(false)
                                                }

                                            }}
                                        />
                                    </TableCell>

                                </TableRow>


                                <TableRow>
                                    <StyledTableHead rowSpan={2}>Espécies</StyledTableHead>
                                    <StyledTableHead>% de Leguminosas</StyledTableHead>
                                    <StyledTableHead>% de Gramíneas</StyledTableHead>
                                </TableRow>
                                <TableRow>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="especies_camp1"
                                            value={obj_anexo?.especies_camp1 === undefined ? '' : obj_anexo?.especies_camp1.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_especies_camp1}
                                            helperText={error_especies_camp1 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="especies_camp2"
                                            value={obj_anexo?.especies_camp2 === undefined ? '' : obj_anexo?.especies_camp2.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_especies_camp2}
                                            helperText={error_especies_camp2 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell></TableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledTableHead>Nutriente </StyledTableHead>
                                    <StyledTableHead>N</StyledTableHead>
                                    <StyledTableHead>P2O5</StyledTableHead>
                                    <StyledTableHead>K2O</StyledTableHead>
                                    <StyledTableHead>Mg</StyledTableHead>
                                    <StyledTableHead>
                                        <CustomTextField
                                            name="nutriente_camp1"
                                            value={obj_anexo?.nutriente_camp1 === undefined ? '' : obj_anexo?.nutriente_camp1}
                                            onChange={onInputChange}
                                        />
                                    </StyledTableHead>
                                    <StyledTableHead>
                                        <CustomTextField
                                            name="nutriente_camp2"
                                            value={obj_anexo?.nutriente_camp2 === undefined ? '' : obj_anexo?.nutriente_camp2}
                                            onChange={onInputChange}
                                        />
                                    </StyledTableHead>
                                    <StyledTableHead>
                                        <CustomTextField
                                            name="nutriente_camp3"
                                            value={obj_anexo?.nutriente_camp3 === undefined ? '' : obj_anexo?.nutriente_camp3}
                                            onChange={onInputChange}
                                        />
                                    </StyledTableHead>
                                    <StyledTableHead>
                                        <CustomTextField
                                            name="nutriente_camp4"
                                            value={obj_anexo?.nutriente_camp4 === undefined ? '' : obj_anexo?.nutriente_camp4}
                                            onChange={onInputChange}
                                        />
                                    </StyledTableHead>
                                </TableRow>
                                <TableRow>
                                    <StyledTableHead>Quantidade (mg/kg)</StyledTableHead>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="quantidade_camp1"
                                            value={obj_anexo?.quantidade_camp1 === undefined ? '' : obj_anexo?.quantidade_camp1.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_quantidade_camp1}
                                            helperText={error_quantidade_camp1 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="quantidade_camp2"
                                            value={obj_anexo?.quantidade_camp2 === undefined ? '' : obj_anexo?.quantidade_camp2.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_quantidade_camp2}
                                            helperText={error_quantidade_camp2 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="quantidade_camp3"
                                            value={obj_anexo?.quantidade_camp3 === undefined ? '' : obj_anexo?.quantidade_camp3.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_quantidade_camp3}
                                            helperText={error_quantidade_camp3 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="quantidade_camp4"
                                            value={obj_anexo?.quantidade_camp4 === undefined ? '' : obj_anexo?.quantidade_camp4.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_quantidade_camp4}
                                            helperText={error_quantidade_camp4 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="quantidade_camp5"
                                            value={obj_anexo?.quantidade_camp5 === undefined ? '' : obj_anexo?.quantidade_camp5.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_quantidade_camp5}
                                            helperText={error_quantidade_camp5 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="quantidade_camp6"
                                            value={obj_anexo?.quantidade_camp6 === undefined ? '' : obj_anexo?.quantidade_camp6.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_quantidade_camp6}
                                            helperText={error_quantidade_camp6 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="quantidade_camp7"
                                            value={obj_anexo?.quantidade_camp7 === undefined ? '' : obj_anexo?.quantidade_camp7.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_quantidade_camp7}
                                            helperText={error_quantidade_camp7 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="quantidade_camp8"
                                            value={obj_anexo?.quantidade_camp8 === undefined ? '' : obj_anexo?.quantidade_camp8.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_quantidade_camp8}
                                            helperText={error_quantidade_camp8 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledTableHead>
                                        A considerar no plano de fertilização nos casos em que
                                        se recorra a esta prática
                                        <Stack direction="row" justifyContent="center">
                                            (kg/ha)
                                            <Box margin={-1} padding={0}>
                                                <BasicPopover
                                                    text={
                                                        "Parcela usada no cálculo automático do campo «previsão total de nutrientes a disponibilizar à cultura» do quadro 3 - Plano de aplicação em função dos resultados das análises ou dos valores tabelados em referência bibliográfica relativamente à composição da adubação verde efetuada."
                                                    }
                                                />
                                            </Box>
                                        </Stack>
                                    </StyledTableHead>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="considerar_camp1"
                                            value={obj_anexo?.considerar_camp1 === undefined ? '' : obj_anexo?.considerar_camp1.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_considerar_camp1}
                                            helperText={error_considerar_camp1 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="considerar_camp2"
                                            value={obj_anexo?.considerar_camp2 === undefined ? '' : obj_anexo?.considerar_camp2.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_considerar_camp2}
                                            helperText={error_considerar_camp2 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="considerar_camp3"
                                            value={obj_anexo?.considerar_camp3 === undefined ? '' : obj_anexo?.considerar_camp3.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_considerar_camp3}
                                            helperText={error_considerar_camp3 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="considerar_camp4"
                                            value={obj_anexo?.considerar_camp4 === undefined ? '' : obj_anexo?.considerar_camp4.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_considerar_camp4}
                                            helperText={error_considerar_camp4 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="considerar_camp5"
                                            value={obj_anexo?.considerar_camp5 === undefined ? '' : obj_anexo?.considerar_camp5.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_considerar_camp5}
                                            helperText={error_considerar_camp5 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="considerar_camp6"
                                            value={obj_anexo?.considerar_camp6 === undefined ? '' : obj_anexo?.considerar_camp6.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_considerar_camp6}
                                            helperText={error_considerar_camp6 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="considerar_camp7"
                                            value={obj_anexo?.considerar_camp7 === undefined ? '' : obj_anexo?.considerar_camp7.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_considerar_camp7}
                                            helperText={error_considerar_camp7 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <CustomTextField
                                            name="considerar_camp8"
                                            value={obj_anexo?.considerar_camp8 === undefined ? '' : obj_anexo?.considerar_camp8.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_considerar_camp8}
                                            helperText={error_considerar_camp8 ? "Apenas números são aceites" : ""}
                                        />
                                    </StyledTableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell
                                        rowSpan={2}
                                        sx={{
                                            textAlign: "left",
                                            fontWeight: 600,
                                            fontFamily: "candara",
                                        }}
                                    >
                                        <Stack
                                            direction="row"
                                            justifyContent="center"
                                            alignItems="center"
                                        >
                                            Origem dos dados:
                                            <BasicPopover
                                                text={
                                                    "Assinalar com uma X o campo correspondente à origem dos dados"
                                                }
                                            />
                                        </Stack>
                                    </TableCell>
                                    <TableCell colSpan={2}>
                                        <Stack
                                            direction="row"
                                            alignItems="center"
                                            justifyContent="left"
                                        >
                                            <FormControlLabel
                                                name="origem_tabela"
                                                label={
                                                    <Typography fontFamily="candara" fontSize={16}>
                                                        a) Tabela - Referência bibliográfica:
                                                    </Typography>
                                                }
                                                aria-readonly
                                                control={
                                                    <Checkbox
                                                        checked={!!obj_anexo?.origem_tabela}
                                                        onChange={onInputChange}
                                                        name="origem_tabela"
                                                        disabled={!flag_editar}
                                                        sx={{
                                                            color: "#aaaaaa",
                                                            "&.Mui-checked": {
                                                                color: "#C94F1E",
                                                            },
                                                        }}
                                                    />
                                                }
                                            />
                                        </Stack>
                                    </TableCell>
                                    <TableCell colSpan={2}>
                                        <CustomTextField
                                            name="tabela"
                                            value={obj_anexo?.tabela === undefined ? '' : obj_anexo?.tabela}
                                            onChange={onInputChange}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={2}>
                                        <Stack
                                            direction="row"
                                            alignItems="center"
                                            justifyContent="left"
                                        >
                                            <FormControlLabel
                                                name="origem_analise"
                                                label={
                                                    <Typography fontFamily="candara" fontSize={16}>
                                                        b) Análise - Data:
                                                    </Typography>
                                                }
                                                aria-readonly
                                                control={
                                                    <Checkbox
                                                        checked={!!obj_anexo?.origem_analise}
                                                        onChange={onInputChange}
                                                        name="origem_analise"
                                                        disabled={!flag_editar}
                                                        sx={{
                                                            color: "#aaaaaa",
                                                            "&.Mui-checked": {
                                                                color: "#C94F1E",
                                                            },
                                                        }}
                                                    />
                                                }
                                            />
                                        </Stack>
                                    </TableCell>
                                    <TableCell colSpan={2}>
                                        <CustomTextField
                                            name="analise"
                                            value={obj_anexo?.analise === undefined ? '' : obj_anexo?.analise}
                                            onChange={onInputChange}
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        )
                    } else {
                        return (
                            <TableBody key={key}>
                                <TableRow>
                                    <TableCell
                                        colSpan={8}
                                        sx={{
                                            fontWeight: 600,
                                            textAlign: "left",
                                            fontFamily: "candara",
                                            fontSize: 16,
                                        }}
                                    >
                                        1.5 - Composição da adubação verde
                                        <BasicPopover
                                            text={
                                                "No caso do beneficiário ter efetuado análises, os boletins de análise devem ser mantidos pelo beneficiário por forma a serem consultados sempre que necessário pelas entidades que monitorizam, verificam a aplicação da legislação nacional aplicável no âmbito da gestão de nutrientes disponibilizados às culturas."
                                            }
                                        />
                                    </TableCell>

                                    <TableCell>
                                        {is_historico === true ? <></> :

                                            <ButtonCadernos
                                                mostrarBotaoEditar
                                                aoClicarEditar={() => {
                                                    set_obj_anexo(tab)
                                                    set_flag_editar(true)
                                                }}
                                                mostrarBotaoApagar
                                                aoClicarApagar={() => {
                                                    set_obj_anexo(tab)
                                                    set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                                                }}
                                            />}
                                    </TableCell>

                                </TableRow>


                                <TableRow>
                                    <StyledTableHead rowSpan={2}>Espécies</StyledTableHead>
                                    <StyledTableHead>% de Leguminosas</StyledTableHead>
                                    <StyledTableHead>% de Gramíneas</StyledTableHead>
                                </TableRow>
                                <TableRow>
                                    <StyledTableCell>{tab.especies_camp1.toString().replace('.', ',')} </StyledTableCell>
                                    <StyledTableCell>{tab.especies_camp2.toString().replace('.', ',')} </StyledTableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell></TableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledTableHead>Nutriente</StyledTableHead>
                                    <StyledTableHead width="8%">
                                        N <BasicPopover text="Azoto" />
                                    </StyledTableHead>
                                    <StyledTableHead width="8%">
                                        P2O5 <BasicPopover text="Fósforo" />
                                    </StyledTableHead>
                                    <StyledTableHead width="8%">
                                        K2O <BasicPopover text="Potássio" />
                                    </StyledTableHead>
                                    <StyledTableHead width="8%">
                                        Mg <BasicPopover text="Magnésio" />
                                    </StyledTableHead>
                                    <StyledTableHead width="8%">
                                        {tab.nutriente_camp1}
                                        <BasicPopover text=" Preencher apenas quando o boletim de análises ou a tabela de referência utilizada apresenta dados sobre outros elementos, que vão ser considerados na elaboração do plano de fertilização." />
                                    </StyledTableHead>
                                    <StyledTableHead width="8%">
                                        {tab.nutriente_camp2}
                                        <BasicPopover text=" Preencher apenas quando o boletim de análises ou a tabela de referência utilizada apresenta dados sobre outros elementos, que vão ser considerados na elaboração do plano de fertilização." />
                                    </StyledTableHead>
                                    <StyledTableHead width="8%">
                                        {tab.nutriente_camp3}
                                        <BasicPopover text=" Preencher apenas quando o boletim de análises ou a tabela de referência utilizada apresenta dados sobre outros elementos, que vão ser considerados na elaboração do plano de fertilização." />
                                    </StyledTableHead>
                                    <StyledTableHead width="8%">
                                        {tab.nutriente_camp4}
                                        <BasicPopover text=" Preencher apenas quando o boletim de análises ou a tabela de referência utilizada apresenta dados sobre outros elementos, que vão ser considerados na elaboração do plano de fertilização." />
                                    </StyledTableHead>
                                </TableRow>
                                <TableRow>
                                    <StyledTableHead>Quantidade (mg/kg) </StyledTableHead>
                                    <StyledTableCell>
                                        {tab.quantidade_camp1.toString().replace('.', ',')}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {tab.quantidade_camp2.toString().replace('.', ',')}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {tab.quantidade_camp3.toString().replace('.', ',')}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {tab.quantidade_camp4.toString().replace('.', ',')}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {tab.quantidade_camp5.toString().replace('.', ',')}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {tab.quantidade_camp6.toString().replace('.', ',')}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {tab.quantidade_camp7.toString().replace('.', ',')}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {tab.quantidade_camp8.toString().replace('.', ',')}
                                    </StyledTableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledTableHead>
                                        A considerar no plano de fertilização nos casos em que
                                        se recorra a esta prática (kg/ha)
                                        <BasicPopover
                                            text={
                                                "Parcela usada no cálculo automático do campo «previsão total de nutrientes a disponibilizar à cultura» do quadro 3 - Plano de aplicação em função dos resultados das análises ou dos valores tabelados em referência bibliográfica relativamente à composição da adubação verde efetuada."
                                            }
                                        />
                                    </StyledTableHead>
                                    <StyledTableCellRight>
                                        {tab.considerar_camp1.toString().replace('.', ',')}
                                        <BasicPopover text="Inserir valores recomendados nas Tabelas de Referência ou os resultados das análises." />
                                    </StyledTableCellRight>
                                    <StyledTableCell>
                                        {tab.considerar_camp2.toString().replace('.', ',')}
                                        <BasicPopover text="Inserir valores recomendados nas Tabelas de Referência ou os resultados das análises." />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {tab.considerar_camp3.toString().replace('.', ',')}
                                        <BasicPopover text="Inserir valores recomendados nas Tabelas de Referência ou os resultados das análises." />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {tab.considerar_camp4.toString().replace('.', ',')}
                                        <BasicPopover text="Inserir valores recomendados nas Tabelas de Referência ou os resultados das análises." />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {tab.considerar_camp5.toString().replace('.', ',')}
                                        <BasicPopover text="Inserir valores recomendados nas Tabelas de Referência ou os resultados das análises." />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {tab.considerar_camp6.toString().replace('.', ',')}
                                        <BasicPopover text="Inserir valores recomendados nas Tabelas de Referência ou os resultados das análises." />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {tab.considerar_camp7.toString().replace('.', ',')}
                                        <BasicPopover text="Inserir valores recomendados nas Tabelas de Referência ou os resultados das análises." />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {tab.considerar_camp8.toString().replace('.', ',')}
                                        <BasicPopover text="Inserir valores recomendados nas Tabelas de Referência ou os resultados das análises." />
                                    </StyledTableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell
                                        rowSpan={2}
                                        sx={{
                                            fontWeight: 600,
                                            fontFamily: "candara",
                                        }}
                                    >
                                        <Stack
                                            direction="row"
                                            justifyContent="center"
                                            alignItems="center"
                                        >
                                            Origem dos dados:
                                            <BasicPopover
                                                text={
                                                    "Assinalar com uma X o campo correspondente à origem dos dados"
                                                }
                                            />
                                        </Stack>
                                    </TableCell>
                                    <TableCell colSpan={4}>
                                        <Stack
                                            direction="row"
                                            alignItems="center"
                                            justifyContent="left"
                                        >
                                            <FormControlLabel
                                                name="origem_tabela"
                                                label={
                                                    <Typography fontFamily="candara" fontSize={16}>
                                                        a) Tabela - Referência bibliográfica:
                                                    </Typography>
                                                }
                                                aria-readonly
                                                control={
                                                    <Checkbox
                                                        checked={!!tab.origem_tabela}
                                                        onChange={onInputChange}
                                                        name="origem_tabela"
                                                        disabled={!flag_editar}
                                                        sx={{
                                                            color: "#aaaaaa",
                                                            "&.Mui-checked": {
                                                                color: "#C94F1E",
                                                            },
                                                        }}
                                                    />
                                                }
                                            />
                                        </Stack>
                                    </TableCell>
                                    <TableCell colSpan={4}>{tab.tabela}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={4}>
                                        <Stack
                                            direction="row"
                                            alignItems="center"
                                            justifyContent="left"
                                        >
                                            <FormControlLabel
                                                name="origem_analise"
                                                label={
                                                    <Typography fontFamily="candara" fontSize={16}>
                                                        b) Análise - Data:
                                                    </Typography>
                                                }
                                                aria-readonly
                                                control={
                                                    <Checkbox
                                                        checked={!!tab.origem_analise}
                                                        onChange={onInputChange}
                                                        name="origem_analise"
                                                        disabled={!flag_editar}
                                                        sx={{
                                                            color: "#aaaaaa",
                                                            "&.Mui-checked": {
                                                                color: "#C94F1E",
                                                            },
                                                        }}
                                                    />
                                                }
                                            />
                                        </Stack>
                                    </TableCell>
                                    <TableCell colSpan={4}>{tab.analise}</TableCell>
                                </TableRow>

                            </TableBody>
                        );
                    }


                })}
            </table>
            <ConfirmDialog
                open={open_dialog_tem_a_certeza_que_quer_eliminar}
                onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
                onConfirm={handle_delete_anexo}
                message="Deseja eliminar o registo?"
            />
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                onConfirm={() => handleCloseDialog()}
                message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
        </TableContainer>
    );
};